<template>
  <div class="adv">
    <!-- 轮播图 -->
    <div class="banner">
      <div class="img">
        <img src="@/assets/imgs/exhibition.jpg" alt="" class="image" />
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 路由导航 -->
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">

          <el-breadcrumb-item>公共教育</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 中部内容 -->
      <div class="teach-content">
        <!-- 版心盒子 -->
        <div class="teach-box" @scroll="handleScroll($event)">
          <div class="teach-pub" v-for="(item, i) in list" :key="item.data">
            <!-- 左侧内容 -->
            <div class="teach-left">
              <div class="teach-title" @click="jumpHandler(item.id)">
                <!-- 让公共教育真正走进公众的心中 -->
                【{{item.eduActivityTypeName}}】{{ item.title }}
              </div>
              <div class="teach-dat">日期: {{ item.createTime }}</div>
              <div class="teach-con" v-html="item.content">
                <!-- 随着新冠肺炎疫情防控形势的向好，人们熟悉的大众生活已经回归。
                    江苏省美术馆公共教育部面向社会推出“云观展·童抗疫”为主题的线上少年儿童美术书法作品征集和展示活动，
                    用儿童喜欢的绘画方式，带着孩子去认知疫情，用孩子们自己的创作向世界传递温暖与友爱。
                    会推出“云观展·童抗疫”为主题的线上<br>
                    会推出“云观展·童抗疫”为主题的线上少年儿童美术书法作品征集和展示活动，
                    用儿童喜欢的绘画方式，带着孩子去认知疫情，用孩子们自己的创作向世界传递温暖与友爱。 -->
              </div>
            </div>
            <!-- 右侧图片 -->
            <div class="teach-right">
              <img
                v-lazy="$axios.defaults.baseURL + item.params.reallyFilePath"
                alt=""
                @click="jumpHandler(item.id)"
              />
              <!-- {{item.imgId}} -->
            </div>
          </div>
          <div class="load" v-if="nextFlag">
            <a-spin v-if="tipMessage != '数据已加载完!'" /><span
              class="load-text"
              >{{ tipMessage }}</span
            >
          </div>
          <div v-if="finalFlag" class="load">
            <span class="load-text">{{ tipMessage }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 5,
      },
      nextFlag: true,
      finalFlag: false,
      tipMessage: "努力加载中...",
      list: [],
      informationData: [],
      arr: [],
      imgArr: [],
    };
  },
  methods: {
    jumpHandler(id) {
      this.$router.push(`/education/detail?id=${id}`);
    },
    handleScroll(event) {
      console.log(123232323);
      let Scroll = event.target;
      //滚动条到底部的条件
      if (
        Scroll.scrollHeight - (Scroll.scrollTop + Scroll.clientHeight) > 10 &&
        !this.nextFlag &&
        !this.finalFlag
      ) {
        this.nextFlag = true;
        this.page.pageNum++;
        setTimeout(() => {
          this.getList();
        }, 1000);
      }
    },
    async getImg() {
      //       await that.$axios.get("/frontapi/edu/main/list?publishStatus=1").then(function (res) {
      //       console.log(res);
      //   //that.list=res.data.rows;
      //       //that.informationData = res.data.rows;
      //       that.arr = res.data.rows.map((item) => {
      //         return item.imgId;
      //       });
      //       that.arr = that.arr.join();
      // console.log(that.arr+'this is arr');
      //     });
      var that = this;
      await this.$axios.get(`/common/fileInfo/${that.arr}`).then((res) => {
        this.imgArr = res.data.data.map((item, i) => {
          return that.$axios.defaults.baseURL + item.filePath;
        });
        console.log(this.imgArr, "this is imgArr");
        console.log(that.informationData, "that.informationData");
      });
      this.imgArr = this.imgArr.reverse();
    },
    async getList() {
      var that = this;
      await this.$axios({
        method: "get",
        url: "/frontapi/edu/main/list",
        params: {
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
          publishStatus: 1,
        },
        data: {},
      }).then(
        function(res) {
          console.log(res);
          that.informationData = [...that.informationData, ...res.data.rows];
          that.list = [...that.list, ...res.data.rows];
          console.log(that.informationData + " that.informationData");
          if (res.data.rows.length == 0) {
            that.tipMessage = "数据已加载完!";
            that.finalFlag = true;
          }
          that.nextFlag = false;
          //           let dataArr = res.data.rows.map((item) => {
          //            return item.imgId;
          //       }).join();
          // console.log(dataArr,'dataArr');
          //          that.arr =  that.arr.concat(dataArr);
          //        console.log( that.arr,' that.ar');
          //       //that.arr = that.arr.join();
          // console.log(that.arr+'this is arr');
        },
        function() {
          // console.log("请求失败");
        }
      );
      //await this.getImg();
    },
  },
  //  mounted() {
  //     var that = this;
  //     console.log('this',this)
  //       this.$axios.get('/frontapi/edu/main/list').then(function(res){
  //            console.log(res);
  //            that.list=res.data.rows
  //       }, function(){
  //           // console.log("请求失败");
  //       });
  // }
  async mounted() {
    var that = this;
    //   var that = this;
    // console.log('this',this)
    //   this.$axios.get('/frontapi/edu/main/list').then(function(res){
    //        console.log(res);
    //        that.list=res.data.rows
    //   }, function(){
    //       // console.log("请求失败");
    //   });
    //      let x = await  that.$axios.get(`/common/fileInfo/588`).then((res) => {
    //
    //          return res.data;
    //   console.log(x,'this is x');

    //     });
    await this.getList();

    //     await that.$axios.get("/frontapi/edu/main/list?publishStatus=1").then(function (res) {
    //       console.log(res);
    //   //that.list=res.data.rows;
    //       //that.informationData = res.data.rows;
    //       that.arr = res.data.rows.map((item) => {
    //         return item.imgId;
    //       });
    //       that.arr = that.arr.join();
    // console.log(that.arr+'this is arr');
    //     });

    //     await that.$axios.get(`/common/fileInfo/${that.arr}`).then((res) => {
    //       this.imgArr =res.data.data.map((item, i) => {
    //          return that.$axios.defaults.baseURL + item.filePath;
    //       });
    //      console.log(this.imgArr,'this is imgArr');
    //       console.log(that.informationData,'that.informationData');
    //     });
    //      this.imgArr=this.imgArr.reverse();
  },
};
</script>
<style scoped>
::v-deep .mapTipWindow li {
  font-size: 18px;
}
img {
  font-size: 18px;
}
.nav >>> .el-breadcrumb__inner.is-link {
  font-weight: 500;
  text-decoration: none;
  color: #606266;
}
* {
  margin: 0;
  padding: 0;
}
i {
  font-style: normal;
}
.adv {
  min-width: 1141px;
  height: 100%;
  background: #f4f4f4;
  padding-top: 1.111111rem /* 80px -> 1.111111rem */;
}
.banner {
  width: 100%;
  height: auto;
}
.banner .img {
  width: 100%;
  height: auto;
}
.image {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  padding-top: 60px;
}
.nav {
  font-size: 18px;
  width: 1199px;
  height: 18px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.about >>> .nav {
  cursor: pointer;
}
.about >>> .is-link {
  font-weight: 400;
  color: #606266;
  /* cursor: text; */
}
.nav >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.teach-content {
  height: 1060px;
  width: 100%;
}

.teach-box {
  width: 1200px;
  height: 990px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  padding: 0 30px;
  overflow: scroll;
}
.teach-box::-webkit-scrollbar {
  display: none;
}
.teach-pub {
  min-height: 210px;
  width: 100%;
  /* background: pink; */
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.teach-left {
  width: 793px;
  margin-right: 27px;
  height: 180px;
  /* background: chartreuse; */
  overflow: hidden;
}
.teach-right {
  width: 320px;
  min-height: 210px;
  /* background: chocolate; */
}
img {
  width: 231px;
  height: 260px;
  align-items: center;
}
.teach-title {
  width: 730px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  margin-bottom: 10px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.teach-dat {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  margin-bottom: 8px;
}
.teach-con {
  width: 793px;
  height: 125px;
  font-size: 14px;
  line-height: 24px;
  color: #222222;
  font-family: SourceHanSansCN-;
  font-weight: 500px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  /* background: yellow; */
}
.teach-con-a {
  width: 792px;
  height: 60px;
  font-size: 16px;
  background: pink;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
}
.load {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  transition: all 2s;
}
::v-deep .ant-spin-dot-item {
  background-color: #b78c0d;
  /* color: #b78c0d; */
}
.load-text {
  margin-left: 10px;
  font-size: 14px;
}
</style>
